import React from 'react';
import styled from 'styled-components';
import { Drawer } from 'antd';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-close {
    color: ${props => props.theme.TextColor};
  }
  .ant-drawer-close:hover {
    color: ${props => props.theme.TextColor};
  }
  .ant-drawer-title {
    color: ${props => props.theme.TextColor};
  }
  .ant-drawer-header {
    background: ${props => props.theme.LayoutBodyBackground};
  }
  .ant-drawer-content {
    color: ${props => props.theme.TextColor};
    background: ${props => props.theme.LayoutBodyBackground};
  }
`;

//niente offset laterale: in antd lo style del Drawer finisce sul wrapper che contiene
//anche la mask, e l'overlay resterebbe scoperto per quei pixel
const NwDrawer = ({ children, ...rest }) => {
  return (
    <StyledDrawer {...rest}>
      {children}
    </StyledDrawer>
  );
};

export default NwDrawer;